import config from '../config';
import { request } from './api';
export default {
  getAudioInfo(dealerId) {
    const domain = config.dealerCloudArVr;
    const url = domain + '/znztguide/v1/audio?appId=dealervr';
    return request({
      type: 'get',
      data: { dealerId },
      url,
      crossDomain: true,
      xhrFields: { withCredentials: true },
      dataType: 'json',
      contentType: 'application/json;charset=UTF-8',
    });
  },
  getGuideSetting(dealerId, sceneId) {
    const domain = config.dealerCloudArVr;
    const url = domain + '/znztguide/v1/getGuideSetting?_appId=dealervr';
    return request({
      type: 'get',
      data: { dealerId, sceneId },
      url,
      crossDomain: true,
      xhrFields: { withCredentials: true },
      dataType: 'json',
      contentType: 'application/json;charset=UTF-8',
    });
  },
};
